import {getSubstanceFormDefaultValues} from '@/modules/drug-catalog/substances/functions'
import {Box, Grid} from '@chakra-ui/react'
import {FormSection} from '@cypro/ui/components/form/form-section'
import {FormGrid} from '@cypro/ui/components/ui/form-grid'
import {withForm} from '@cypro/ui/integrations/form'
import {useTranslate} from '@tolgee/react'

export const AlternativeCodesTab = withForm({
  defaultValues: getSubstanceFormDefaultValues(undefined),
  render: function Render({form}) {
    const {t} = useTranslate('common')
    const {t: tSubstances} = useTranslate('substances')

    return (
      <Grid gapY="8">
        <FormSection
          label={tSubstances('nomenclature_codes')}
          description={tSubstances('nomenclature_codes_description')}
        >
          <FormGrid>
            <form.AppField name="prescribingName">
              {field => (
                <field.TextField
                  size="sm"
                  label={t('prescribing_name')}
                  placeholder={tSubstances('prescribing_name_placeholder')}
                />
              )}
            </form.AppField>

            <form.AppField name="nationalId">
              {field => (
                <field.TextField
                  size="sm"
                  label={t('national_id')}
                  placeholder={tSubstances('national_id_placeholder')}
                />
              )}
            </form.AppField>

            <form.AppField name="atcCode">
              {field => (
                <field.TextField size="sm" label={t('atc_code')} placeholder={tSubstances('atc_code_placeholder')} />
              )}
            </form.AppField>

            <form.AppField name="code">
              {field => (
                <field.TextField
                  size="sm"
                  label={t('internal_id')}
                  placeholder={tSubstances('internal_id_placeholder')}
                />
              )}
            </form.AppField>

            <form.AppField name="externalInformationLink">
              {field => (
                <field.TextField
                  size="sm"
                  type="url"
                  label={t('external_information_link')}
                  placeholder="https://pubchem.ncbi.nlm.nih.gov/compound/Cyclophosphamide"
                />
              )}
            </form.AppField>
          </FormGrid>
        </FormSection>

        <FormSection label={tSubstances('additional_notes')} description={tSubstances('additional_notes_description')}>
          <FormGrid>
            <Box gridColumn="span 2">
              <form.AppField name="description">
                {field => (
                  <field.Textarea
                    size="sm"
                    label={t('description')}
                    placeholder={tSubstances('description_placeholder')}
                    rows={4}
                  />
                )}
              </form.AppField>
            </Box>
          </FormGrid>
        </FormSection>
      </Grid>
    )
  },
})
